import axios from "axios";

/**
 * AdtBedService
 *
 * Service for the IPD bed-type / bed lookup used by the admission bed picker
 * (RegisterPatientForIpd + BedPickerInline, ADT-001). Follows the singleton
 * pattern of InsuranceDetailsService / DischargeSummaryService.
 *
 * ── BACKEND CONTRACT ──
 *
 *   GET {BASE}ipd_bedtype/
 *     Wards (bed types) with facility-wide total/available counts.
 *
 *   GET {BASE}ipd_bed/?bed_type_code=<>
 *     Beds of a ward. A bed belongs to no department, so neither call is
 *     department-scoped any more.
 */

const BASE = process.env.REACT_APP_BACKEND_ROUTE_URL;

class AdtBedService {
  // ─── Wards (bed types), facility-wide ────────────────────────────────
  /**
   * @param {object} headers - Auth headers (Bearer token).
   * @returns {Promise<object>} Server response (bed types under .bedtype_list / .data / etc).
   */
  async listBedTypes(headers) {
    const response = await axios.get(`${BASE}ipd_bedtype/`, { headers });
    return response.data;
  }

  // ─── Beds of a ward ──────────────────────────────────────────────────
  /**
   * @param {{ bedTypeCode: string }} filters
   * @param {object} headers - Auth headers (Bearer token).
   * @returns {Promise<object>} Server response (beds under .bed_list / .data / etc).
   */
  async listBeds({ bedTypeCode }, headers) {
    const response = await axios.get(`${BASE}ipd_bed/`, {
      headers,
      params: { bed_type_code: bedTypeCode },
    });

    return response.data;
  }
}

const adtBedServiceInstance = new AdtBedService();
export default adtBedServiceInstance;
